import React from 'react';
import styled from 'styled-components';
import {
  SYS_COLOR_FOREGROUND_NEUTRAL_100_DARK,
  SYS_COLOR_FOREGROUND_NEUTRAL_400_DARK,
} from '@oneaudi/unified-web-alpha-common-v2';

const DotsContainer = styled.div`
  display: flex;
  width: fit-content;
`;

const Dot = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 4px;
  border: none;
  background-color: transparent;
  height: 40px;
  cursor: pointer;
`;

const Bar = styled.div<{ isActive: boolean }>`
  width: 32px;
  height: ${(props) => (props.isActive ? '4px' : '2px')};
  background-color: ${(props) =>
    props.isActive ? SYS_COLOR_FOREGROUND_NEUTRAL_100_DARK : SYS_COLOR_FOREGROUND_NEUTRAL_400_DARK};
  transition: all 0.5s;
`;

interface PaginationDotsAlphaProps {
  currentIndex: number;
  totalSlides: number;
  goToSlide: (index: number) => void;
}

const PaginationDotsAlpha: React.FC<PaginationDotsAlphaProps> = ({
  currentIndex,
  totalSlides,
  goToSlide,
}) => {
  return (
    <DotsContainer>
      {Array.from({ length: totalSlides }).map((_, index) => (
        <Dot
          aria-label={`Featured Offer ${index} of ${totalSlides}`}
          data-testid={`pagination-featured-offer${index}of${totalSlides}`}
          key={index}
          onClick={() => goToSlide(index)}
        >
          <Bar isActive={index === currentIndex} />
        </Dot>
      ))}
    </DotsContainer>
  );
};

export default PaginationDotsAlpha;
